import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { Box, IconButton, Stack, Typography, Icons } from "@curves/ui-base";
import { CLUB_HOME_ROUTER } from "@icoach/router/routerPath";
import { localClub } from "@util/utils";
import InventoryNav from "../components/InventoryNav";
import NavLogo from "@images/nav_logo.svg";

/**
 * 店鋪庫存管理系統頂部 Header
 */
const InventoryHeader = ({ className }) => {
	const { text: clubName } = localClub.get() || {};

	return (
		<Box className={clsx("club-inventory-header", className)}>
			<Stack className="club-inventory-header-content" justifyContent="space-between" alignItems="center" spacing={2}>
				<Stack className="club-inventory-header-left" alignItems="center" spacing={2}>
					<InventoryNav.Trigger />
					<img src={NavLogo} alt="Curves" className="club-inventory-header-logo" />
					<Stack className="club-inventory-header-title" alignItems="center" spacing={2}>
						<Typography>店鋪庫存</Typography>
						{clubName && <Typography>{clubName}</Typography>}
					</Stack>
				</Stack>
				<IconButton variant="contained" className="club-inventory-exit-button" component={Link} to={CLUB_HOME_ROUTER.ARRIVE}>
					<Icons.Reply htmlColor={'#fff'} />
				</IconButton>
			</Stack>
		</Box>
	);
};

export default InventoryHeader;
